/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Duration_HelpInputs */

const en_transcript_export_duration_help = /** @type {(inputs: Transcript_Export_Duration_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the duration of empty space between events before creating a new paragraph. For example, if the space between two events exceeds 4 seconds a new paragraph will be created for the second event.`)
};

const fr_transcript_export_duration_help = /** @type {(inputs: Transcript_Export_Duration_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definissez la duree d'espace vide entre les evenements avant de creer un nouveau paragraphe. Par exemple, si l'espace entre deux evenements depasse 4 secondes, un nouveau paragraphe sera cree pour le second evenement.`)
};

const de_transcript_export_duration_help = /** @type {(inputs: Transcript_Export_Duration_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legen Sie die Dauer des Leerraums zwischen Ereignissen fest, bevor ein neuer Absatz erstellt wird. Wenn beispielsweise der Abstand zwischen zwei Ereignissen 4 Sekunden überschreitet, wird für das zweite Ereignis ein neuer Absatz erstellt.`)
};

const it_transcript_export_duration_help = /** @type {(inputs: Transcript_Export_Duration_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta la durata dello spazio vuoto tra gli eventi prima di creare un nuovo paragrafo. Ad esempio, se lo spazio tra due eventi supera i 4 secondi, verrà creato un nuovo paragrafo per il secondo evento.`)
};

const ru_transcript_export_duration_help = /** @type {(inputs: Transcript_Export_Duration_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задайте длительность пустого пространства между событиями перед созданием нового абзаца. Например, если промежуток между двумя событиями превышает 4 секунды, новый абзац будет создан для второго события.`)
};

const es_transcript_export_duration_help = /** @type {(inputs: Transcript_Export_Duration_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Establezca la duración del espacio vacío entre eventos antes de crear un nuevo párrafo. Por ejemplo, si el espacio entre dos eventos supera los 4 segundos, se creará un nuevo párrafo para el segundo evento.`)
};

const zh_cn2_transcript_export_duration_help = /** @type {(inputs: Transcript_Export_Duration_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置事件之间创建新段落前的空白时长。例如，如果两个事件之间的空白超过 4 秒，则会为第二个事件创建一个新段落。`)
};

const ja_transcript_export_duration_help = /** @type {(inputs: Transcript_Export_Duration_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい段落を作成する前に、イベント間の空白の期間を設定します。例えば、2つのイベント間の空白が4秒を超える場合、2番目のイベントに対して新しい段落が作成されます。`)
};

const hi_transcript_export_duration_help = /** @type {(inputs: Transcript_Export_Duration_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया पैराग्राफ बनाने से पहले घटनाओं के बीच खाली स्थान की अवधि निर्धारित करें। उदाहरण के लिए, यदि दो घटनाओं के बीच का अंतराल 4 सेकंड से अधिक हो जाता है, तो दूसरी घटना के लिए एक नया पैराग्राफ बनाया जाएगा।`)
};

const pt_pt2_transcript_export_duration_help = /** @type {(inputs: Transcript_Export_Duration_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defina a duração do espaço vazio entre os eventos antes de criar um novo parágrafo. Por exemplo, se o espaço entre dois eventos exceder 4 segundos, um novo parágrafo será criado para o segundo evento.`)
};

/**
* | output |
* | --- |
* | "Set the duration of empty space between events before creating a new paragraph. For example, if the space between two events exceeds 4 seconds a new paragrap..." |
*
* @param {Transcript_Export_Duration_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_duration_help = /** @type {((inputs?: Transcript_Export_Duration_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Duration_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_duration_help(inputs)
	if (locale === "de") return de_transcript_export_duration_help(inputs)
	if (locale === "it") return it_transcript_export_duration_help(inputs)
	if (locale === "ru") return ru_transcript_export_duration_help(inputs)
	if (locale === "es") return es_transcript_export_duration_help(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_duration_help(inputs)
	if (locale === "ja") return ja_transcript_export_duration_help(inputs)
	if (locale === "hi") return hi_transcript_export_duration_help(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_duration_help(inputs)
	return en_transcript_export_duration_help(inputs)
});